import {LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import './sbk-messenger.scss';

@customElement('sbk-sbk-messenger')
export class SbkSbkMessenger extends LitElement {

    protected createRenderRoot() {
        return this;
    }
}
